// Avoid loading the react-pdf library unless actually rendering a pdf

//import {pdf} from './PdfExportStore'
export const A4_PAGE_SIZE = 'A4'


// WEBPACK FOOTER //
// ./src/modules/pdf/global.ts